import { render, staticRenderFns } from "./PromotedBadge.vue?vue&type=template&id=7fd5eec0&scoped=true&"
import script from "./PromotedBadge.vue?vue&type=script&lang=ts&"
export * from "./PromotedBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd5eec0",
  null
  
)

export default component.exports